<!-- src/components/Loading.vue -->
<template>
  <div 
    class="loading-mask"
    :style="maskStyle"
  >
    <div 
      class="loading-wrapper"
      :style="wrapperStyle"
    >
      <div 
        class="loading-spinner"
        :style="spinnerStyle"
      ></div>
      <div 
        class="loading-text"
        :style="textStyle"
      >{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    text: {
      type: String,
      default: '加载中...'
    },
    background: {
      type: String,
      default: 'rgba(0, 0, 0, 0.7)'
    },
    position: {
      type: String,
      default: 'center',
      validator: (value) => [
        'center',
        'top-left',
        'top-right',
        'bottom-left',
        'bottom-right'
      ].includes(value)
    },
    maskFullscreen: {
      type: Boolean,
      default: true
    },
    wrapperWidth: {
      type: [String, Number],
      default: 'auto'
    },
    wrapperHeight: {
      type: [String, Number],
      default: 'auto'
    },
    spinnerSize: {
      type: [String, Number],
      default: 40
    },
    textSize: {
      type: [String, Number],
      default: 14
    }
  },
  computed: {
    maskStyle() {
      return {
        backgroundColor: this.background,
        position: this.maskFullscreen ? 'fixed' : 'absolute',
        display: 'flex',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        ...this.positionStyle
      }
    },
    positionStyle() {
      return {
        'center': { justifyContent: 'center', alignItems: 'center' },
        'top-left': { justifyContent: 'flex-start', alignItems: 'flex-start' },
        'top-right': { justifyContent: 'flex-end', alignItems: 'flex-start' },
        'bottom-left': { justifyContent: 'flex-start', alignItems: 'flex-end' },
        'bottom-right': { justifyContent: 'flex-end', alignItems: 'flex-end' }
      }[this.position]
    },
    wrapperStyle() {
      return {
        width: this.addUnit(this.wrapperWidth),
        height: this.addUnit(this.wrapperHeight),
        textAlign: this.position === 'center' ? 'center' : 'left',
        padding: '20px'
      }
    },
    spinnerStyle() {
      return {
        width: this.addUnit(this.spinnerSize),
        height: this.addUnit(this.spinnerSize),
        borderWidth: this.addUnit(Math.min(3, this.spinnerSize / 10))
      }
    },
    textStyle() {
      return {
        fontSize: this.addUnit(this.textSize)
      }
    }
  },
  methods: {
    addUnit(value) {
      return typeof value === 'number' ? `${value}px` : value
    }
  }
}
</script>

<style scoped>
.loading-mask {
  z-index: 5;
}

.loading-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.loading-spinner {
  border: 3px solid #5fc6ff;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 0.8s linear infinite;
  margin: 0 auto;
}

.loading-text {
  color: #5fc6ff;
  margin-top: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>